import { getLanguagePack } from '../i18n';

export function getTransportFacts(): readonly string[] {
  return getLanguagePack().transportFacts;
}

export const TRANSPORT_FACTS = getTransportFacts();
